import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AppModel from '../DataModel/AppModel';

// id |   name   |          description          | allow_children
// ----+----------+-------------------------------+----------------
// B  | Building | A separate building           | t
// S  | Section  | A section or subsection       | t
// R  | Room     | A named room                  | f


export default
@observer class SelectRoomType extends Component {

  handleChange(event, index, value) {
    console.log(arguments);
    this.props.target.id_type = value;
  }

  render() {
    return (
      <SelectField
          floatingLabelText={uiMsg('SRT_TYPE_OF_LOCATION',"Type of Location")}
          hintText={uiMsg('SRT_TYPE_OF_LOCATION_HINT',"Room/Area type")}
          value={this.props.target.id_type}
          fullWidth={true}
          onChange={this.handleChange.bind(this)}>
          {AppModel.locationTypes.map( lt =>
            <MenuItem key={lt.id} value={lt.id} primaryText={lt.typeName} />
          )}
      </SelectField>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectRoomType.jsx
 **/